// 企业身份
import UltMeta, { Meta } from "./UltMeta/index";

class SupplierRoleType extends UltMeta {
    INVENTORY_MANAGEMENT = new Meta(3, "进销存企业");
    WAREHOUSE_SUPERVISION = new Meta(4, "仓储业务企业");
    WAREHOUSE_MANAGE_SUPERVISION = new Meta(6, "仓储管理企业");
}

export const SUPPLIER_ROLE_TYPE = new SupplierRoleType();
